import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FFB800" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink target="_blank" href="https://www.facebook.com/Golden-Spring-Restaurant-112490475876625/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Golden Spring Facebook"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.zomato.com/vancouver/golden-spring-restaurant-grandview-vancouver/menu">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Golden Spring Zomato"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/golden-spring-restaurant-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Golden Spring Yelp"
                hover
              />
            </CFLink>
            {/*<CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Golden Spring Instagram"
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FFB800" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink target="_blank" href="https://www.facebook.com/Golden-Spring-Restaurant-112490475876625/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Golden Spring Facebook"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.zomato.com/vancouver/golden-spring-restaurant-grandview-vancouver/menu">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Golden Spring Zomato"
                hover
              />
            </CFLink>
            <CFLink target="_blank" href="https://www.yelp.ca/biz/golden-spring-restaurant-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Golden Spring Yelp"
                hover
              />
            </CFLink>
            {/*<CFLink href="https://www.instagram.com/hoshi_sushibar/?hl=en">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Golden Spring Instagram"
                hover
              />
            </CFLink>*/}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
